/* ADD GROUPS */
export const GET_QUESTION = "GET_QUESTION"
export const GET_QUESTION_SUCCESS = "GET_QUESTION_SUCCESS"
export const GET_QUESTION_CLEAN = "GET_QUESTION_CLEAN"
export const GET_QUESTION_ERROR = "GET_QUESTION_ERROR"
